import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
// import Ionicon from 'react-ionicons';
import styles from './sidebar-jss';

import ListIcon from '@material-ui/icons/List';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import { logout } from '../../helper/helper';
const LinkBtn = React.forwardRef(function LinkBtn(props, ref) { // eslint-disable-line
  return <NavLink to={props.to} {...props} innerRef={ref} />; // eslint-disable-line
});

let page="";
// eslint-disable-next-line
class MainMenu extends React.Component {
  openurl(geturl) {
    const url = geturl;
    window.open(url, '_blank');
  }
  componentDidMount() {
    page =window.location.pathname;
    page =page.split('/');
  }
  render() {
    const {
      classes
    } = this.props;
    return (
      <div>
        <ListItem
          button
          className={classNames(classes.head, page[1] === 'offerings' || page[1] === 'offering-detail' ? ` ${classes.active}` : '')}
          component={LinkBtn}
          to={{pathname: "/offerings",
          DSPView: true}}
        >
          <ListItemIcon className={classes.icon}>
            <ListIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} invariant="inset" primary={'Offerings'} />
        </ListItem>

        <ListItem
          button
          className={classes.head}
          onClick={logout}
        >
          <ListItemIcon className={classes.icon}>
            <ExitToAppRoundedIcon />
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.primary }} variant="inset" primary={'Sign Out'} />
        </ListItem>
      </div>
    );
  }
}

MainMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDrawerOpen: PropTypes.func.isRequired
};


const mapStateToProps = state => ({
  force: state, // force active class for sidebar menu
});

const mapDispatchToProps = dispatch => ({
});

const MainMenuMapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainMenu);

export default withStyles(styles)(MainMenuMapped);
